import React from 'react';
import Icon from '../../../components/AppIcon';

const RecentActivity = ({ activities }) => {
  const getActivityIcon = (type) => {
    switch (type) {
      case 'inquiry': return 'MessageSquare';
      case 'view': return 'Eye';
      case 'favorite': return 'Heart';
      case 'listing': return 'Home';
      case 'verification': return 'CheckCircle';
      default: return 'Activity';
    }
  };

  const getActivityColor = (type) => {
    switch (type) {
      case 'inquiry': return 'text-primary bg-blue-50';
      case 'view': return 'text-secondary bg-emerald-50';
      case 'favorite': return 'text-error bg-red-50';
      case 'listing': return 'text-warning bg-yellow-50';
      case 'verification': return 'text-success bg-green-50';
      default: return 'text-text-secondary bg-muted';
    }
  };

  const formatTimeAgo = (date) => {
    const now = new Date();
    const activityDate = new Date(date);
    const diffInMinutes = Math.floor((now - activityDate) / (1000 * 60));
    
    if (diffInMinutes < 1) return 'Just now';
    if (diffInMinutes < 60) return `${diffInMinutes}m ago`;
    if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}h ago`;
    return `${Math.floor(diffInMinutes / 1440)}d ago`;
  };

  return (
    <div className="bg-surface rounded-lg border border-border p-6 shadow-property-card">
      <h3 className="text-lg font-semibold text-text-primary mb-4">Recent Activity</h3>
      <div className="space-y-4">
        {activities.map((activity, index) => (
          <div key={index} className="flex items-start space-x-3">
            <div className={`p-2 rounded-lg ${getActivityColor(activity.type)}`}>
              <Icon name={getActivityIcon(activity.type)} size={16} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between">
                <p className="text-sm font-medium text-text-primary line-clamp-1">
                  {activity.title}
                </p>
                <span className="text-xs text-text-secondary">
                  {formatTimeAgo(activity.timestamp)}
                </span>
              </div>
              <p className="text-xs text-text-secondary line-clamp-2 mt-1">
                {activity.description}
              </p>
              {activity.propertyTitle && (
                <p className="text-xs text-primary mt-1">
                  Property: {activity.propertyTitle}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecentActivity;